import md5 from "md5";
import { message } from "ant-design-vue";
export function localGet(KEY) {
  const value = localStorage.getItem(KEY);
  try {
    return JSON.parse(decodeURIComponent(localStorage.getItem(KEY)));
  } catch (error) {
    return value;
  }
}

// 设置localStorage
export function localSet(KEY, VALUE) {
  localStorage.setItem(KEY, encodeURIComponent(JSON.stringify(VALUE)));
}

// 删除localStorage
export function localRemove(KEY) {
  localStorage.removeItem(KEY);
}

export const imageFilter = (URL) => {
  if (URL && URL.slice(0, 8) === "textbook") {
    return "https://univ-common.oss-cn-hangzhou.aliyuncs.com/" + URL;
  } else {
    return URL;
  }
};

// 密码加密规则
export const scretPassword = (TEXT) => {
  return md5(`${TEXT}{resource}`);
};

// 复制文案
export const copyText = (TEXT) => {
  const input = document.createElement("input");
  input.style.position = "fixed";
  input.style.opacity = 0;
  input.value = TEXT;
  document.body.appendChild(input);
  input.select();
  try {
    const successful = document.execCommand("copy");
    message.success(successful ? "复制成功！" : "复制失败！");
  } catch (err) {
    message.error("复制失败！");
  }
  document.body.removeChild(input);
};
